import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {ISetHubSizes} from './set-hub-sizes';
import {SetHubSizesService} from './set-hub-sizes.service';

@Component({
    //templateUrl: 'app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.component.html',
     template: require('./set-hub-sizes.component.html'),
    directives: [ROUTER_DIRECTIVES],
    providers:[SetHubSizesService]
})

export class SetHubSizesComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Set Hub Sizes';
    errorMessage: string;
    private sub: any;
    setHubSizesResult: ISetHubSizes;
    
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _setHubSizesService:SetHubSizesService) {
        this.setHubSizesResult = new ISetHubSizes("Completed set hub sizes stored procedure"); 
    }

    ngOnInit(): void{
      this._setHubSizesService.getSetHubSizesResponse()
          .subscribe(
               setHubSizesResult => this.setHubSizesResult = setHubSizesResult,
               error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.component.ts
 **/